import IndexedDb from '../Dependency/IndexedDb';

const database = 'test';
const tables = ['test', 'trees', 'validated_queue'];
export const TABLE_TREES = 'trees';
export const TABLE_VALIDATED_QUEUE = 'validated_queue';
const db = new IndexedDb(database, tables);

async function openDb(onError?: Function) {
  return db.createObjectStore(tables).catch(err => {
    console.error(err);
    onError && onError(err);
  });
}

async function countRecords(tablename: string, onError?: Function) {
  const count = await db.count(tablename).catch(err => {
    console.error(err);
    onError && onError(err);
  });
  return count;
}

function deleteDb(onError?: Function) {
  return db.delete().catch(err => {
    console.error(err);
    onError && onError(err);
  });
}

function getValue(tableName: string, id: number, onError?: Function) {
  return db.getValue(tableName, id).catch(err => {
    console.error(err);
    onError && onError(err);
  });
}

function getAllValue(tableName: string, onError?: Function) {
  return db.getAllValue(tableName).catch(err => {
    console.error(err);
    onError && onError(err);
  });
}

function getAllKeys(tableName: string, onError?: Function) {
  return db.getAllKeys(tableName).catch(err => {
    console.error(err);
    onError && onError(err);
  });
}

function putValue(tableName: string, value: object, key?: string, onError?: Function) {
  return db.putValue(tableName, value, key).catch(err => {
    console.error(err);
    onError && onError(err);
  });
}

function putBulkValue(tableName: string, value: object[], onError?: Function) {
  return db.putBulkValue(tableName, value).catch(err => {
    console.error(err);
    onError && onError(err);
  });
}

async function deleteValue(tableName: string, id: any, onError?: Function) {
  return await db.deleteValue(tableName, id).catch(err => {
    console.error(err);
    onError && onError(err);
  });
}

async function getCursor(tableName: string, callback: Function) {
  let cursor = await db.getCursor(tableName);
  while (cursor) {
    await callback(cursor);
    cursor = cursor && await cursor.continue();
  }
}

function getIDB() {
  return db;
}

export default {
  openDb,
  deleteDb,
  getValue,
  getAllKeys,
  getAllValue,
  putValue,
  putBulkValue,
  deleteValue,
  getCursor,
  countRecords,
  getIDB
};
